export default "__VITE_ASSET__c561c8e1__"